import { Link } from 'react-router-dom';
import PublishStagingButton from './PublishStagingButton';

interface Props {
  active: 'queue' | 'listings' | 'events' | 'blog' | 'resources' | 'tips';
}

const TABS: ReadonlyArray<{ key: Props['active']; to: string; label: string }> = [
  { key: 'queue', to: '/admin', label: 'Hàng đợi duyệt' },
  { key: 'listings', to: '/admin/listings', label: 'Lớp học' },
  { key: 'events', to: '/admin/events', label: 'Sự kiện' },
  { key: 'blog', to: '/admin/blog', label: 'Bài viết' },
  { key: 'resources', to: '/admin/resources', label: 'Tài nguyên' },
  { key: 'tips', to: '/admin/tips', label: 'Gợi ý' },
];

export default function AdminTabs({ active }: Props) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 mb-6 text-sm">
      <nav className="flex flex-wrap gap-1">
        {TABS.map((t) => (
          <Link
            key={t.key}
            to={t.to}
            className={`px-4 py-1.5 rounded-full font-semibold transition-colors ${
              active === t.key
                ? 'bg-red-50 text-red-700 border border-red-100'
                : 'text-gray-600 hover:text-red-700 border border-transparent'
            }`}
          >
            {t.label}
          </Link>
        ))}
      </nav>
      <PublishStagingButton />
    </div>
  );
}
